import { TextField, useTheme } from "@mui/material";
import React from "react";

interface IChatTextField {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onEnterPress?: () => void;
  placeHolderText?: string;
  helperText?: string;
}

export const ChatTextField = (props: IChatTextField) => {
  const { value, onChange, onBlur, onFocus, onEnterPress, placeHolderText, helperText } = props;
  const theme = useTheme();
  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (onEnterPress) {
        onEnterPress();
      }
    }
  };

  return (
    <TextField
      id="title"
      name="title"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={handleKeyDown}
      multiline
      maxRows={4}
      slotProps={{
        htmlInput: { maxLength: 2000 },
        formHelperText: {
          sx: {
            fontSize: "0.75rem", // Smaller font size
            //color: "blue", // Custom color
            //fontStyle: "italic", // Italic text
            paddingLeft: "15px",
          },
        },
      }}
      error={!!helperText}
      helperText={helperText}
      placeholder={placeHolderText ?? "Ask AMI..."}
      sx={{
        fontSize: "16px",
        color: theme.palette.grey[700],
        background: "transparent",
        width: "100%",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
        },
        "& .MuiOutlinedInput-input": {
          outline: "none",
        },
        "& .MuiInputBase-input": {
          outline: "none",
        },
      }}
    />
  );
};
